export class TerminalBlockModel {
    id?: string | null = null;
    locationId?: string | null = null; // Updated to match API
    manufacturer?: string | null = null;
    modelNumber?: string | null = null;
    serialNumber?: string | null = null;
    exMarking?: string | null = null;
    certificationNumber?: string | null = null;
    ratedMaximumDissipatedPower?: number | null = null; // Dropdown: N/A, Direct Input
    junctionBoxId?: string | null = null; // Keep for backward compatibility
    createdAt?: string | null = null; // Match API field name
    updatedAt?: string | null = null; // Match API field name
    terminalBlockData?: TerminalBlockDataModel[] | null = null;

    constructor(data?: Partial<TerminalBlockModel>) {
        Object.assign(this, data);
    }
}

export class TerminalBlockDataModel {
    id?: string | null = null;
    terminalBlockId?: string | null = null;
    type?: 'current' | 'cross-section' | 'value' | null = null;
    value?: string | null = null;
    currentId?: string | null = null;
    crossSectionId?: string | null = null;
    createdAt?: string | null = null;
    updatedAt?: string | null = null;

    constructor(data?: Partial<TerminalBlockDataModel>) {
        Object.assign(this, data);
    }
}

export interface TerminalBlockSaveDto {
    id?: string;
    locationId: string;
    manufacturer: string;
    modelNumber: string;
    serialNumber: string;
    exMarking: string;
    certificationNumber: string;
    ratedMaximumDissipatedPower?: number | null;
}

export interface TerminalBlockDataValueDto {
    value: string;
}

export interface TerminalBlockTableCellDto {
    currentId: string;
    crossSectionId: string;
    value: string;
}

export interface TerminalBlockStructuredResponse {
    terminalBlock: TerminalBlockModel;
    currents: TerminalBlockDataModel[];
    crossSections: TerminalBlockDataModel[];
    matrix: {[currentId: string]: {[crossSectionId: string]: string}};
    tableValues: TerminalBlockDataModel[];
}

export interface TerminalBlockMatrix {
    currents: TerminalBlockDataModel[];
    crossSections: TerminalBlockDataModel[];
    matrix: {[currentId: string]: {[crossSectionId: string]: string}};
    tableValues: TerminalBlockDataModel[];
}
